export const MAKES = ["Dodge", "Chrysler", "Ram"];

export const MODELS_BY_MAKE = {
    Dodge: ["Charger", "Challenger"],
    Chrysler: ["300"],
    Ram: ["1500 TRX", "1500 RHO", "1500 Limited"],
};

export const ALL_MODELS = ["Charger", "Challenger", "300", "1500 TRX", "1500 RHO", "1500 Limited"];

export const ENGINES = [
    "5.7L HEMI V8",
    "6.1L HEMI V8",
    "6.4L HEMI V8",
    "6.2L Supercharged HEMI V8",
    "Hurricane 3.0L I6 High Output",
];

export const PERFORMANCE_PACKAGES = [
    "R/T",
    "Scat Pack",
    "Scat Pack Widebody",
    "SRT8",
    "SRT Hellcat",
    "SRT Hellcat Widebody",
    "SRT Hellcat Redeye",
    "SRT Hellcat Redeye Widebody",
    "SRT Super Stock",
    "SRT Demon",
    "SRT Demon 170",
    "TRX",
    "RHO",
    "Limited",
];

export const DRIVETRAINS = ["RWD", "AWD", "4WD"];
export const TRANSMISSIONS = ["Automatic", "Manual"];
export const MODS_LEVELS = ["Stock", "Street", "Track", "Full Send"];
export const SELLER_TYPES = [
    { value: "private", label: "Private Seller" },
    { value: "dealer", label: "Dealer" },
];

export const SORT_OPTIONS = [
    { value: "recent", label: "Newest listings" },
    { value: "price_low", label: "Price: Low to high" },
    { value: "price_high", label: "Price: High to low" },
    { value: "mileage_low", label: "Lowest mileage" },
    { value: "year_new", label: "Newest year" },
];

export const CATEGORIES = [
    { value: "builds", label: "Builds & Showoffs", short: "Builds" },
    { value: "parts", label: "Parts Wanted / For Sale", short: "Parts" },
    { value: "tech", label: "Tech Help & Diagnostics", short: "Tech" },
    { value: "events", label: "Events & Meets", short: "Events" },
    { value: "general", label: "General Chat", short: "General" },
    { value: "marketplace-discussion", label: "Marketplace Discussion", short: "Market" },
];

export const CURRENT_YEAR = new Date().getFullYear();
export const MAX_LISTING_YEAR = CURRENT_YEAR + 1;
export const MIN_LISTING_YEAR = 1970;

export function formatPrice(n) {
    if (n == null) return "—";
    return `$${Number(n).toLocaleString("en-US")}`;
}

export function formatMileage(n) {
    if (n == null) return "—";
    return `${Number(n).toLocaleString("en-US")} mi`;
}

export function timeAgo(iso) {
    if (!iso) return "";
    const d = new Date(iso);
    const diff = (Date.now() - d.getTime()) / 1000;
    if (diff < 60) return "just now";
    if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
    if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`;
    return d.toLocaleDateString();
}
